<template>
	<frontend-layout>
		<!-- <inertia-head title="首頁-國立中央大學校園授權軟體" /> -->
		<Head>
			<title>{{ $t("home") }} - {{ $t("siteTitle") }}</title>
		</Head>
		<header id="header" class="header">
			<div class="container">
				<div class="row">
					<div class="col-lg-6 col-xl-5">
						<div class="text-container">
							<div class="section-title">
								{{ $t("NCUCCFull") }}
							</div>
							<h1 class="h1-large" data-aos="fade-up">
								{{ $t("CAService") }}
							</h1>
							<p
								class="p-large"
								id="notice-mobile"
								data-aos="fade-up"
								data-aos-delay="100">
								<span class="text-red">{{
									$t("homepage.notice1") +
									"。" +
									$t("homepage.notice2") +
									"。" +
									$t("homepage.notice3")
								}}</span>
							</p>
							<p
								class="p-large"
								id="notice-desktop"
								data-aos="fade-up"
								data-aos-delay="100">
								<span class="text-red">{{
									$t("homepage.notice1")
								}}</span>
								<br />
								{{ $t("homepage.notice2") }}
								<br />
								{{ $t("homepage.notice3") }}
							</p>
							<a class="btn-solid-lg" href="#services">{{
								$t("homepage.relatedServices")
							}}</a>
							<template
								v-if="!user"
								data-aos="fade-in"
								data-aos-delay="100">
								<InertiaLink href="/login" class="quote">
									<span
										class="ts-icon is-sign-in-icon"></span>
									<!-- {{ __("navbar.login") }} -->
									{{ $t("login") }}
								</InertiaLink>
							</template>
						</div>
					</div>
					<div class="col-lg-6 col-xl-7">
						<div class="image-container">
							<img
								class="img-fluid"
								src="/img/ncu_software.webp"
								alt="alternative" />
						</div>
					</div>
					<div class="arrow bounce">
						<a
							class="
								ts-icon
								is-angles-down-icon is-huge
								arrow-font
							"
							href="#detailsUp"></a>
					</div>
				</div>
			</div>
		</header>
		<div id="detailsUp">&nbsp;</div>
		<div id="details" class="basic-1">
			<div class="container">
				<div class="row">
					<div class="col-lg-6 col-xl-4">
						<div class="image-container">
							<img
								data-aos="flip-left"
								data-aos-duration="500"
								class="img-fluid"
								src="/img/guoguo.webp"
								alt="alternative" />
						</div>
					</div>
					<div class="col-lg-6 col-xl-8">
						<div class="text-container">
							<h2 class="component-title">
								{{ $t("homepage.news") }}
							</h2>

							<news></news>
							<InertiaLink
								aria-current="announcements"
								href="/announcements"
								class="float-end">
								<!-- {{ __("index.more_Annoucements") }} -->
								{{ $t("homepage.moreNews") }}
								<span
									class="ts-icon is-angle-right-icon"></span>
							</InertiaLink>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div id="services" class="cards-1">
			<div class="container">
				<div class="row">
					<div class="col-lg-12">
						<div
							data-aos="fade-up"
							data-aos-delay="100"
							class="card">
							<div class="card-icon blue">
								<span class="ts-icon is-file-icon"></span>
							</div>
							<div class="card-body">
								<h5 class="card-title">
									{{ $t("homepage.commonApps") }}
								</h5>
								<p>{{ $t("homepage.commonAppsSub") }}</p>
								<ul class="list-unstyled li-space-lg">
									<li class="d-flex">
										<span
											class="
												ts-icon
												is-check-icon
											"></span>
										<div class="flex-grow-1">
											{{ $t("homepage.windows") }}
										</div>
									</li>
									<li class="d-flex">
										<span
											class="
												ts-icon
												is-check-icon
											"></span>
										<div class="flex-grow-1">
											{{ $t("homepage.office") }}
										</div>
									</li>
									<li class="d-flex">
										<span
											class="
												ts-icon
												is-check-icon
											"></span>
										<div class="flex-grow-1">
											{{ $t("homepage.antivirus") }}
										</div>
									</li>
									<li class="d-flex">
										<span
											class="
												ts-icon
												is-check-icon
											"></span>
										<div class="flex-grow-1">
											{{ $t("homepage.freeSoftware") }}
										</div>
									</li>
								</ul>
								<div class="box bg-1">
									<InertiaLink
										href="/download"
										class="
											button
											button--aylen
											button--round-l
											button--text-thick
										">
										{{ $t("homepage.goDownload") }}
									</InertiaLink>
								</div>
							</div>
						</div>
						<!-- end of card -->

						<!-- Card -->
						<div
							data-aos="fade-up"
							data-aos-delay="200"
							class="card">
							<div class="card-icon yellow">
								<span class="ts-icon is-compass-icon"></span>
							</div>
							<div class="card-body">
								<h5 class="card-title">
									{{ $t("homepage.installTutorial") }}
								</h5>
								<p>{{ $t("homepage.faq") }}</p>
								<ul class="list-unstyled li-space-lg">
									<li class="d-flex">
										<span
											class="
												ts-icon
												is-check-icon
											"></span>
										<div class="flex-grow-1">
											{{ $t("homepage.handson") }}
										</div>
									</li>
									<li class="d-flex">
										<span
											class="
												ts-icon
												is-check-icon
											"></span>
										<div class="flex-grow-1">
											{{ $t("homepage.activation") }}
										</div>
									</li>
									<li class="d-flex">
										<span
											class="
												ts-icon
												is-check-icon
											"></span>
										<div class="flex-grow-1">
											{{ $t("homepage.errorCode") }}
										</div>
									</li>
									<li class="d-flex">
										<span
											class="
												ts-icon
												is-check-icon
											"></span>
										<div class="flex-grow-1">
											{{ $t("homepage.manual") }}
										</div>
									</li>
								</ul>
								<div class="box bg-1">
									<InertiaLink
										href="/docs"
										class="
											button
											button--aylen
											button--round-l
											button--text-thick
										">
										{{ $t("homepage.goDocs") }}
									</InertiaLink>
								</div>
							</div>
						</div>
						<!-- end of card -->

						<!-- Card -->
						<div
							data-aos="fade-up"
							data-aos-delay="300"
							class="card">
							<div class="card-icon red">
								<span
									class="
										ts-icon
										is-circle-question-icon
									"></span>
							</div>
							<div class="card-body">
								<h5 class="card-title">
									{{ $t("homepage.problemReport") }}
								</h5>
								<p>{{ $t("homepage.problemReportSub") }}</p>
								<ul class="list-unstyled li-space-lg">
									<li class="d-flex">
										<span
											class="
												ts-icon
												is-check-icon
											"></span>
										<div class="flex-grow-1">
											{{
												$t(
													"homepage.problemReportDetail1"
												)
											}}
											<br />
											{{
												$t(
													"homepage.problemReportDetail2"
												)
											}}
											<br />
											{{
												$t(
													"homepage.problemReportDetail3"
												)
											}}
										</div>
									</li>
									<li class="d-flex">
										<span
											class="
												ts-icon
												is-check-icon
											"></span>
										<div class="flex-grow-1">
											{{ $t("homepage.inpersonSupport") }}
										</div>
									</li>
								</ul>
								<div class="box bg-1">
									<InertiaLink
										href="/problemReport"
										class="
											button
											button--aylen
											button--round-l
											button--text-thick
										">
										{{ $t("homepage.goSupport") }}
									</InertiaLink>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</frontend-layout>
</template>

<script>
// import components
import FrontendLayout from "@/Frontend/Shared/Layout";
import detail from "@/Frontend/Pages/Home/announcement/detail";
import news from "@/Frontend/Components/limit_news";

export default {
	name: "index",
	data() {
		return {};
	},
	methods: {},
	mounted() {},
	components: {
		FrontendLayout,
		detail,
		news,
	},
	computed: {
		user() {
			return this.$page.props.auth?.user;
		},
	},
};
</script>

<style scoped>
.arrow {
	text-align: center;
	margin: 8% 0 0 0;
}
.arrow-2 {
	text-align: center;
	margin: 3% 0 0 0;
}

#detailsUp {
	padding-top: 1px;
}
.arrow-font {
	text-decoration: none;
}
.bounce {
	-moz-animation: bounce 2s infinite;
	-webkit-animation: bounce 2s infinite;
	animation: bounce 2s infinite;
}

@keyframes bounce {
	0%,
	20%,
	50%,
	80%,
	100% {
		transform: translateY(0);
	}
	40% {
		transform: translateY(-30px);
	}
	60% {
		transform: translateY(-15px);
	}
}
#notice-desktop {
	display: block;
}
#notice-mobile {
	display: none;
}
@media only screen and (max-width: 600px) {
	#notice-desktop {
		display: none;
	}
	#notice-mobile {
		display: block;
	}
}
.card {
	height: auto;
}

.component-title {
	width: 100%;
	text-align: center;
}

.image-container {
	padding-top: 5.1rem;
}
/* carousel */
.car {
	width: 100%;
}

.carousel-text h3 {
	font-size: 15%;
}

.carousel-caption {
	color: rgb(92, 39, 216);
	text-align: center;
	top: 50%;
	transform: translateY(-50%);
	bottom: initial;
}

.carousel-photo {
	opacity: 0.8;
}

.news_title {
	-webkit-writing-mode: vertical-lr;
	writing-mode: vertical-lr;
}

.more {
	color: black;
}

/* Aylen */
.button.button--aylen {
	background: #fff;
	color: #37474f;
	border-color: #2a141b;
	overflow: hidden;
	-webkit-transition: color 0.3s;
	transition: color 0.3s;
}
.button--aylen.button--inverted {
	background: none;
	color: #fff;
}

.button--text-thick {
	font-weight: 600;
}
.button--round-s {
	border-radius: 5px;
}
.button--round-m {
	border-radius: 15px;
}
.button--round-l {
	border-radius: 40px;
}
.bg-1 {
	color: #37474f;
	margin-top: 10px;
}

.box {
	display: -webkit-flex;
	display: -ms-flexbox;
	display: flex;
	-webkit-flex-wrap: wrap;
	-ms-flex-wrap: wrap;
	flex-wrap: wrap;
	-webkit-justify-content: center;
	justify-content: center;
}

/* Common button styles */
.button {
	float: left;
	display: block;
	padding: 1em 2em;
	border: black 5px;
	background: none;
	color: inherit;
	vertical-align: middle;
	position: relative;
	z-index: 1;
	-webkit-backface-visibility: hidden;
	-moz-osx-font-smoothing: grayscale;
}
.button:focus {
}
.button > span {
	vertical-align: middle;
}

/* Text color adjustments (we could stick to the "inherit" but that does not work well in Safari) */
.bg-1 .button {
	color: #9a596c;
	border-color: #fffbe3;
}
.bg-2 .button {
	color: #eceff1;
	border-color: #eceff1;
}
.bg-3 .button {
	color: #9a596c;
	border-color: #fffbe3;
}

/* Sizes */
.button--size-s {
	font-size: 14px;
}
.button--size-m {
	font-size: 16px;
}
.button--size-l {
	font-size: 18px;
}
</style>
